import React, { ReactNode, useEffect, useState } from "react";
import { useFormContext, useWatch } from "react-hook-form";

import styles from "./index.module.scss";

import TextInput from "../TextInput";
import TextLink from "../TextLinks";
import ErrorMessage from "../ErrorMessage";

type PropsType = {
  section?: string;
  id: string;
  maxInputs: number;
  label: string;
  tooltip?: ReactNode;
  maxLength?: number;
  readOnly?: boolean;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  fieldOptions?: any;
};

const TextGrid = ({
  section,
  id,
  maxInputs,
  label,
  tooltip,
  maxLength,
  readOnly,
  fieldOptions,
}: PropsType) => {
  const {
    formState: { errors },
  } = useFormContext();

  const idDotFormat = (() => {
    if (section) {
      return `${section}.${id}`;
    }
    return `${id}`;
  })();

  const error = section && errors[section] ? errors[section][id] : errors[id];

  const curInputs = useWatch({ name: idDotFormat });
  const [numInputs, setNumInputs] = useState(
    Array.isArray(curInputs) ? curInputs.length : 1
  );
  const [needAutoFocus, setNeedAutoFocus] = useState(false)

  useEffect(() => {
    setNumInputs(Array.isArray(curInputs) ? curInputs.length : 1);
  }, [curInputs]);

  const inputs = [...Array(numInputs)].map((_e, i) => (
    // eslint-disable-next-line react/no-array-index-key
    <React.Fragment key={`tg-${id}-${i}`}>
      <TextInput
        section={section}
        id={`${id}.${i}`}
        maxLength={maxLength}
        readOnly={readOnly}
        autoFocus={needAutoFocus}
        fieldOptions={fieldOptions}
      />
    </React.Fragment>
  ));

  return (
    <div>
      <p className={styles.labelText}>
        {label} {tooltip}
      </p>
      {error && (
        <ErrorMessage className={styles.errorMessage} field={idDotFormat}>
          {`Cannot exceed ${maxLength} characters`}
        </ErrorMessage>
      )}
      <div className={styles.textGrid}>{inputs}</div>
      {!readOnly && numInputs < maxInputs && (
        <TextLink
          onClick={() => {
            setNumInputs(numInputs + 1);
            setNeedAutoFocus(true);
          }}
        >
          + Add Field
        </TextLink>
      )}
    </div>
  );
};

export default TextGrid;
